import document from './document.reducer';
import documents from './documents.reducer';

const reducer = {
  documents,
  document,
};

export default reducer;
